import { createQmsAdapter } from '@nextgis/qms-kit';

import type { Type } from '@nextgis/utils';
import type { MainLayerAdapter, TileAdapterOptions } from '@nextgis/webmap';

import type { GetClassAdapterOptions } from '../interfaces';

export async function createBasemapLayerAdapter({
  webMap,
  item,
}: GetClassAdapterOptions): Promise<Type<MainLayerAdapter> | undefined> {
  if (item.basemap_layer) {
    const qms = item.basemap_layer.qms;
    const url = item.basemap_layer.url;
    if (qms) {
      const qms_ = JSON.parse(qms);
      const adapter = Promise.resolve(
        createQmsAdapter(webMap, {
          qms: qms_,
          baselayer: true,
        }),
      );
      return adapter;
    } else if (url) {
      const TileAdapter = webMap.mapAdapter.layerAdapters.TILE as Type<
        MainLayerAdapter<any, any, TileAdapterOptions>
      >;
      if (TileAdapter) {
        class BasemapTileAdapter extends TileAdapter {
          async addLayer(opt: TileAdapterOptions) {
            if (url) {
              return super.addLayer({ ...opt, url });
            }
          }
        }
        return BasemapTileAdapter;
      }
    }
  }
}
